import { render, staticRenderFns } from "./SelectProducts.vue?vue&type=template&id=4a808860&scoped=true&"
import script from "./SelectProducts.vue?vue&type=script&lang=js&"
export * from "./SelectProducts.vue?vue&type=script&lang=js&"
import style0 from "./SelectProducts.vue?vue&type=style&index=0&id=4a808860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a808860",
  null
  
)

export default component.exports